import { ChapterPromotion } from './ChapterPromotion'
import { withBookPromotion } from './withChapterPromotion'

const ConnectedChapterPromotion = withBookPromotion(ChapterPromotion)

export { ConnectedChapterPromotion as ChapterPromotion }
